import { render, staticRenderFns } from "./LocaleLink.vue?vue&type=template&id=6c77bbf6&"
import script from "./LocaleLink.vue?vue&type=script&lang=js&"
export * from "./LocaleLink.vue?vue&type=script&lang=js&"
import style0 from "./LocaleLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports